"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helpers = require("./helpers");

var _default = {
  Content: {
    '& .disabled': {
      pointerEvents: 'none',
      opacity: '30%'
    }
  },
  Box: function Box(_ref) {
    var theme = _ref.theme,
        props = _ref.props;
    return {
      boxSizing: 'border-box',
      display: props.open ? 'block' : 'none',
      width: '180px',
      border: "1px solid ".concat(theme['$menu-border-color']),
      position: 'absolute',
      background: theme['$background-color'],
      boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.14)',
      minHeight: '95px',
      borderRadius: ' 6px',
      left: (0, _helpers.getVertical)(props),
      top: (0, _helpers.getHorizontal)(props),
      zIndex: 100
    };
  },
  Arrow: {
    display: 'block',
    position: 'absolute',
    '&:before, &:after': {
      content: '""',
      position: 'absolute'
    }
  },
  Bottom: function Bottom(_ref2) {
    var theme = _ref2.theme,
        props = _ref2.props;
    return {
      left: (0, _helpers.getArrowLeft)(props),
      transform: 'translate(-50%, 0)',
      bottom: '100%',
      width: '16px',
      height: '10px',
      '&:before, &:after': {
        bottom: 0
      },
      '&:before': {
        borderLeft: '7px solid transparent',
        borderRight: '7px solid transparent',
        borderBottom: "10px solid ".concat(theme['$menu-border-color']),
        left: 0
      },
      '&:after': {
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: "9px solid ".concat(theme['$background-color']),
        left: 1
      }
    };
  },
  Left: function Left(_ref3) {
    var theme = _ref3.theme,
        props = _ref3.props;
    return {
      left: '100%',
      transform: 'translate(0, 50%)',
      bottom: (0, _helpers.getArrowVertical)(props),
      width: '10px',
      height: '16px',
      '&:before, &:after': {
        left: 0
      },
      '&:before': {
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent',
        borderLeft: "10px solid ".concat(theme['$menu-border-color']),
        bottom: 0
      },
      '&:after': {
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderLeft: "9px solid ".concat(theme['$background-color']),
        bottom: 1
      }
    };
  },
  Right: function Right(_ref4) {
    var theme = _ref4.theme,
        props = _ref4.props;
    return {
      right: '100%',
      transform: 'translate(0, 50%)',
      bottom: (0, _helpers.getArrowVertical)(props),
      width: '10px',
      height: '16px',
      '&:before, &:after': {
        right: 0
      },
      '&:before': {
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent',
        borderRight: "10px solid ".concat(theme['$menu-border-color']),
        bottom: 0
      },
      '&:after': {
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderRight: "9px solid ".concat(theme['$background-color']),
        bottom: 1
      }
    };
  },
  Top: function Top(_ref5) {
    var theme = _ref5.theme,
        props = _ref5.props;
    return {
      left: (0, _helpers.getArrowLeft)(props),
      transform: 'translate(-50%, 0)',
      top: '100%',
      width: '16px',
      height: '10px',
      '&:before, &:after': {
        'top': 0
      },
      '&:before': {
        borderLeft: '7px solid transparent',
        borderRight: '7px solid transparent',
        borderTop: "10px solid ".concat(theme['$menu-border-color']),
        left: 0
      },
      '&:after': {
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: "9px solid ".concat(theme['$background-color']),
        left: 1
      }
    };
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map